export type SaveStepStatus = 'disabled' | 'pending' | 'processing' | 'success' | 'fail';

// How many items the step is about to persist, split by what the save will do
// with each of them. All-zero means "no counts to show" (the entity-model step
// never has any) and the tooltip shows the bare step label instead.
export type SaveStepCounts = {
  created: number;
  removed: number;
  updated: number;
};

export const EMPTY_SAVE_STEP_COUNTS: SaveStepCounts = {
  created: 0,
  removed: 0,
  updated: 0
};

export const getSaveStepTotal = (counts: SaveStepCounts): number => counts.created + counts.updated + counts.removed;

export type SaveStep = {
  counts: SaveStepCounts;
  status: SaveStepStatus;
};

export type SaveSteps = {
  venues: SaveStep;
  // Attribution torus rings. Batched into the same zone requests as `screens`,
  // but counted and shown separately because the user edits them separately.
  attributionZones: SaveStep;
  screens: SaveStep;
  entityModel: SaveStep;
};
